import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import businessSetting from './modules/businessSetting' // 导入settings模块
import { getInfo, logout, emalogin } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: getToken(),
    lang: 'en', // 初始未选择默认 en 英文
    // 是否有余额
    isBalance: true,
    user: {},
    shopcar: [],
    userinfo: {},
    utop: {},
    onlineSetting: {},
    startTime: ''
  },
  mutations: {
    // 设置是否有余额
    SET_ISBALANCE (state, isBalance) {
      state.isBalance = isBalance
    },
    SET_TOKEN (state, token) {
      state.token = token
    },
    STAET_USER (state, user) {
      state.user = user
      sessionStorage.setItem('user', JSON.stringify(user))
    },
    SET_USERINFO (state, userinfo) {
      state.userinfo = userinfo
    },
    SET_SHOPCAR (state, shopcar) {
      state.shopcar = shopcar || []
      console.log('SET_SHOPCAR========', shopcar)
      sessionStorage.setItem('shopcar', JSON.stringify(state.shopcar) || [])
    },
    utop (state, utop) {
      state.utop = utop
    },
    SET_ONLINESETTING (state, onlineSetting) {
      state.onlineSetting = onlineSetting
    },
    SET_STARTTIME (state, startTime) {
      state.startTime = startTime
      sessionStorage.setItem('startTime', startTime)
    }
  },
  actions: {
    // 登录
    LoginEmail ({ commit }, userInfo) {
      const token = userInfo.token
      return new Promise((resolve, reject) => {
        emalogin(token).then(res => {
          console.log('登录成功:', res)
          if (res.code == 200) {
            commit('SET_TOKEN', res.data.jwtToken)
            localStorage.setItem('user', JSON.stringify(res.data.user))
            setToken(res.data.jwtToken)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setUser ({ commit }, user) {
      commit('STAET_USER', user)
    },
    // 获取用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          sessionStorage.setItem('storeid', user.storeid)
          commit('STAET_USER', res.user)
          commit('SET_TOKEN', getToken())

          commit('SET_SHOPCAR', JSON.parse(sessionStorage.getItem('shopcar')) || [])
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出系统
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('STAET_USER', {})
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    setUserinfo ({ commit }, userinfo) {
      commit('SET_USERINFO', userinfo)
    },
    setShopcar ({ commit }, shopcar) {
      commit('SET_SHOPCAR', shopcar)
    }
  },
  modules: {
    businessSetting // 营业设置
  },
  getters
})

export default store
